(function digitalFileTemplateControllerDefinition() {
    'use strict';

    angular.module('DigitalFile')
        .controller('DigitalFileTemplateController', [
            '$scope', 'templateService', 'errorsExtend','$window',
            function templateController($scope, templateService, errors, $window) {
                $scope.load = function () {
                    templateService.getTemplate().then(function (result) {
                        $scope.data = result;                        
                    }, function (error) {
                        $scope.error = error.data.message;
                        });

                    $scope.back = function () {
                        $window.history.back();
                    };
                }
                $scope.load();
            }])
})();